import { render, staticRenderFns } from "./CustomersLookup.vue?vue&type=template&id=6f70805a&scoped=true&"
import script from "./CustomersLookup.vue?vue&type=script&lang=js&"
export * from "./CustomersLookup.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLookup.vue?vue&type=style&index=0&id=6f70805a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70805a",
  null
  
)

export default component.exports